import { Box } from "@mui/material";
import styled from "styled-components";
import selectedTheme from "../../../themes";

export const DropdownItemContainer = styled(Box)`
`

export const DropdownItemStyled = styled(Box)`
    font-family: ${selectedTheme.fonts.textFont};
`